import { RootState } from '../root.reducers';
import { SshSecurityInfo } from './sshSecurityInfo.types';

// eslint-disable-next-line import/prefer-default-export
export const getSshSecurityInfos = (state: RootState): SshSecurityInfo[] => state.sshSecurityInfo.entities;

export const getSshSecurityInfo = (state: RootState): SshSecurityInfo | null => state.sshSecurityInfo.single;

export const getSelectedSshSecurityInfos = (state: RootState): SshSecurityInfo[] => state.sshSecurityInfo.selected;

export const getSshSecurityInfosCreatedId = (state: RootState): string | null => state.sshSecurityInfo.createdId;

export const isSshSecurityInfosCreatePopupOpen = (state: RootState): boolean => state.sshSecurityInfo.ui.isCreatePopupOpen;

export const isSshSecurityInfosLoading = (state: RootState): boolean => state.sshSecurityInfo.ui.isLoading;
